export default "/images/67635d2360f0bbba9e2d9dcf6fb04977.avif";